import { axiosInstanceV1 } from "@rentablo/api";
import { RentabloBlogFeed, FeedItemList } from "../model";

interface Params {
  isin: string;
}

export const getNewsFeed = async (params: Params) => {
  const { data } = await axiosInstanceV1.get<FeedItemList>("/newsFeeds", {
    params,
  });
  return data;
};

export const getNewsFeedRentabloBlog = async (params: RentabloBlogFeed) => {
  const { data } = await axiosInstanceV1.get<FeedItemList>(
    "/newsFeeds/rentabloBlog",
    {
      params,
    }
  );
  return data;
};
